import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  iconRtl: {
    right: "auto",
    left: 0,
  },

  selectRtl: {
    "&.MuiSelect-select": {
      paddingRight: 0,
      paddingLeft: 24,
    },
  },
}));

const IntlSelect = (props) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  return (
    <Select
      {...props}
      classes={{
        icon: clsx({ [classes.iconRtl]: i18n.dir() === "rtl" }),
        select: clsx({ [classes.selectRtl]: i18n.dir() === "rtl" }),
      }}
    >
      {props.children}
    </Select>
  );
};

export default IntlSelect;
